<template>
  <section>
    <h2>Комната 2: {{ this.$store.state.Window2.nameWindow2 }}</h2>
    <v-row
      v-if="this.$store.state.Window2.nameWindow2 === 'Гостиная' || this.$store.state.Window2.nameWindow2 === 'Спальня'"
      dense
      class="pb-3"
    >
      <v-col
        v-for="curtain in kitCurtains1"
        :key="curtain.name"
        class="col-md-4"
      >
          <v-card
            outlined
            :color="background"
          >
            <v-img
              :src="curtain.src"
              class="white--text align-end"
              height="auto"
            >
            </v-img>
            <v-card-actions
              class="actions"
            >
              <v-radio-group v-model.lazy="modelCurtain2">
                <v-radio
                  :label="curtain.name"
                  :value="curtain.name"
                />
              </v-radio-group>
            </v-card-actions>
          </v-card>
      </v-col>
    </v-row>
    <v-row
      v-if="this.$store.state.Window2.nameWindow2 === 'Кухня'"
      dense
      class="pb-3"
    >
      <v-col
        v-for="curtain in kitCurtainsKitchen"
        :key="curtain.name"
        class="col-md-4"
      >
          <v-card
            outlined
            :color="background"
          >
            <v-img
              :src="curtain.src"
              class="white--text align-end"
              height="auto"
            >
            </v-img>
            <v-card-actions
              class="actions"
            >
              <v-radio-group v-model.lazy="modelCurtain2">
                <v-radio
                  :label="curtain.name"
                  :value="curtain.name"
                />
              </v-radio-group>
            </v-card-actions>
          </v-card>
      </v-col>
    </v-row>
    <v-row
      v-if="this.$store.state.Window2.nameWindow2 === 'Детская'"
      dense
      class="pb-3"
    >
      <v-col
        v-for="curtain in kitCurtainsKids"
        :key="curtain.name"
        class="col-md-4"
      >
          <v-card
            outlined
            :color="background"
          >
            <v-img
              :src="curtain.src"
              class="white--text align-end"
              height="auto"
            >
            </v-img>
            <v-card-actions
              class="actions"
            >
              <v-radio-group v-model.lazy="modelCurtain2">
                <v-radio
                  :label="curtain.name"
                  :value="curtain.name"
                />
              </v-radio-group>
            </v-card-actions>
          </v-card>
      </v-col>
    </v-row>
  </section>
</template>

<script>
export default {
  name: 'kitCurtain2',
  computed: {
    modelCurtain2: {
      get () {
        return this.$store.state.Curtains.modelCurtain2
      },
      set (value) {
        this.$store.commit('updateModelCurtain2', value)
      }
    },
    background: {
      get () {
        return this.$store.state.Color.colorRoom2
      }
    },
    kitCurtains1: {
      get () {
        return this.$store.state.Curtains.kitCurtains1
      }
    },
    kitCurtainsKids: {
      get () {
        return this.$store.state.Curtains.kitCurtainsKids
      }
    },
    kitCurtainsKitchen: {
      get () {
        return this.$store.state.Curtains.kitCurtainsKitchen
      }
    }
  },
  methods: {
  }
}
</script>

<style>
.actions{
  background-color: #fff;
  border-color: #333;
}
.theme--light.v-card.v-card--outlined {
    border: thin solid #e8e8e8 !important;
}
.theme--light.v-label {
    color: #000 !important;
}
</style>
